const initialState = {
  success: false,
  loading: false,
  error: null,
  surveys: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  currentSurvey: {
    data: {},
    loading: false,
    error: null,
  },
};

const surveyReducer = (
  state = initialState,
  { obj, type, error, payload, data, pagination }
) => {
  switch (type) {
    case "RESET_SURVEYS":
      return initialState;

    case "GET_SURVEYS":
      return {
        ...state,
        type,
        error: null,
        surveys: {
          ...initialState.surveys,
          loading: true,
        },
      };

    case "GET_SURVEYS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        surveys: {
          ...state.surveys,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_SURVEYS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        surveys: {
          ...state.surveys,
          loading: false,
          error,
        },
      };

    case "SURVEY_APPROVAL":
      return {
        ...state,
        type,
        error: null,
        currentSurvey: {
          ...initialState.currentSurvey,
          loading: true,
        },
      };

    case "SURVEY_APPROVAL_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        currentSurvey: {
          ...state.currentSurvey,
          loading: false,
          data: data.data,
        },
        surveys: {
          ...state.surveys,
          data: state.surveys.data.map((survey) => {
            if (survey.id === data.data.id) {
              survey = {
                ...survey,
                approval_status: data.data.approval_status,
              };
            }
            return survey;
          }),
        },
      };

    case "SURVEY_APPROVAL_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        currentSurvey: {
          ...state.currentSurvey,
          loading: false,
          error,
        },
      };

    default:
      return state;
  }
};

export default surveyReducer;
